import MUTATION_TYPE from '@/store/mutationTypes'
import { MENU_TYPE } from '@/model/components/menu/sideMenuType'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import { State, Login } from './state'
import * as Screen from './stateScreen'

// mutations定義
const mutations = {
  // ログイン認証情報設定
  [MUTATION_TYPE.SET_LOGIN_AUTH](state: State, payload: Login) {
    // ログイン認証情報を設定する
    const { login } = state
    login.username = payload.username
    login.usernamedisp = payload.usernamedisp
    login.csrftoken = payload.csrftoken
  },
  // ログイン認証情報のクリア
  [MUTATION_TYPE.CLEAR_LOGIN_AUTH](state: State) {
    // 認証情報のクリア
    const { login } = state
    login.username = ''
    login.usernamedisp = ''
    login.csrftoken = ''
  },
  // ログイン情報の設定
  [MUTATION_TYPE.SET_LOGIN](state: State) {
    const { header } = state
    header.disp.username = true
    header.disp.logout = true
    header.disp.menu = true
    const { login } = state
    login.status = true
  },
  // ログイン情報のクリア
  [MUTATION_TYPE.CLEAR_LOGIN](state: State) {
    const { header } = state
    header.disp.username = false
    header.disp.logout = false
    header.disp.menu = false
    const { login } = state
    login.status = false
    state.screen.top.username = ''
  },
  // TOP画面遷移時の設定
  [MUTATION_TYPE.SET_TOP](state: State, payload: Screen.Top) {
    const { top } = state.screen
    top.auth = payload.auth
    top.error.data.splice(0)
    payload.error.data.forEach((p) => top.error.data.push(p))
  },
  // TOP画面の認証有無のクリア
  [MUTATION_TYPE.CLEAR_TOP_AUTH](state: State) {
    const { top } = state.screen
    top.auth = false
  },
  // TOP画面遷移時のクリア
  [MUTATION_TYPE.CLEAR_TOP](state: State) {
    const { top } = state.screen
    top.auth = true
    top.error.data.splice(0)
  },
  // 言語切替
  [MUTATION_TYPE.LANGCHANGE](state: State, lang: string) {
    // 言語切替処理
    state.header.language = lang
  },
  // ダウンロード詳細情報設定
  [MUTATION_TYPE.SET_DOWNLOAD_DETAIL](state: State, payload: Screen.DonwloadDetail) {
    const { download } = state.screen
    // 検索有無は立てる
    download.search = true
    // 詳細情報の設定
    const { detail } = download
    detail.key = payload.key
    detail.senddate = payload.senddate
    detail.from = payload.from
    detail.subject = payload.subject
    detail.size = payload.size
    detail.attached = payload.attached
    detail.dispAttached = payload.dispAttached
    detail.dispEml = payload.dispEml
    detail.isFail = payload.isFail
  },
  // ダウンロード詳細情報クリア
  [MUTATION_TYPE.CLEAR_DOWNLOAD_DETAIL](state: State) {
    const { download } = state.screen
    download.search = false
    const { detail } = download
    detail.key = ''
    detail.senddate = ''
    detail.from = ''
    detail.subject = ''
    detail.size = 0
    detail.attached = []
    detail.dispAttached = false
    detail.dispEml = false
    detail.isFail = false
  },
  // ダウンロードデータ無しデータの設定
  [MUTATION_TYPE.SET_DOWNLOAD_NODATA](state: State, errorState: ErrorMsgState) {
    const { download } = state.screen
    download.error?.data.splice(0)
    errorState.data.forEach((p) => download.error?.data.push(p))
  },
  // ダウンロードデータ無しデータのクリア
  [MUTATION_TYPE.CLEAR_DOWNLOAD_NODATA](state: State) {
    const { download } = state.screen
    download.error?.data.splice(0)
  },
  // メニュー情報設定
  [MUTATION_TYPE.MENU_SET](state: State, type: MENU_TYPE) {
    state.menu.selected = type
  },
  // ヘッダー情報のクリア
  [MUTATION_TYPE.CLEAR_HEADER](state: State) {
    const { header } = state
    header.disp.username = false
    header.disp.logout = false
    header.disp.help = false
    header.disp.lang = false
    header.disp.menu = false
  },
  // 他画面情報の設定
  [MUTATION_TYPE.SET_OTHER](state: State) {
    state.other = true
  },
}

export { mutations }
